export default __webpack_public_path__ + "static/campfire-ff9c156e0ed890bb937010261625a683.mp3";